var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuickApplyModalIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7619 75.9994C39.4375 75.9994 50.5238 65.0722 50.5238 51.5927C50.5238 38.1133 39.4375 27.186 25.7619 27.186C12.0863 27.186 1 38.1133 1 51.5927C1 65.0722 12.0863 75.9994 25.7619 75.9994Z",
    fill: "#FCEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7619 10.1018H79V56.4745H28.2381",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2381 51.5935H75.2857",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4286 47.9322V41.8306H29.4762V47.9322",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2381 47.932V36.2168H49.2857V47.932",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1429 47.9321V35.7288H59.1905V47.9321",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0476 47.9319V19.8643H69.0952V47.9319",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3333 47.9321V38.1694H39.381V47.9321",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 75.9998V50.3728",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 16.2033C19.276 16.2033 22.0476 13.4715 22.0476 10.1017C22.0476 6.73181 19.276 4 15.8571 4C12.4382 4 9.66666 6.73181 9.66666 10.1017C9.66666 13.4715 12.4382 16.2033 15.8571 16.2033Z",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19048 76V46.712H2.2381V29.6273C2.2381 24.9095 6.11829 21.085 10.9048 21.085H44.3333V28.407H24.5238V76",
    stroke: "#374354",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 24.7456V27.1863",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8571 29.6267V32.0674",
    stroke: "#E53B34",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickApplyModalIcon);
export default __webpack_public_path__ + "static/media/quick-apply-modal-icon.38e1110b2c053427328819217cd6bcbb.svg";
export { ForwardRef as ReactComponent };